(() => {
  const isClickDummy = (
    window.swinger.config
    && window.swinger.config.isClickDummy
  );

  let csrf = {};

  const setClasses = (isLoggedIn) => {
    const classList = document.documentElement.classList;
    const classGuest = 'is-guest';
    const classAuthenticated = 'is-authenticated';

    if (isLoggedIn) {
      if (classList.contains(classGuest)) {
        classList.remove(classGuest);
      }
      if (!classList.contains(classAuthenticated)) {
        classList.add(classAuthenticated);
      }
    } else {
      if (!classList.contains(classGuest)) {
        classList.add(classGuest);
      }
      if (classList.contains(classAuthenticated)) {
        classList.remove(classAuthenticated);
      }
    }
  };

  const triggerNotifications = (notifications) => {
    if (!window.swinger.snackbar) {
      window.setTimeout(() => {
        triggerNotifications(notifications);
      }, 200);
      return;
    }

    window.swinger.i18n()
      .then((i18n) => {
        if (window.location.search.indexOf('newSignup=1') > -1) {
          window.swinger.snackbar.create({
            isSelfclosing: false,
            isSuppressible: true,
            children: [
              {
                component: 'notification',
                data: {
                  type: 'success',
                  text: i18n('ui.user.registration-success'),
                },
              },
            ],
          });
        }

        notifications
          .forEach((notification, index) => {
            const content = notification[window.swinger.config.language] || notification;

            window.setTimeout(() => {
              window.swinger.snackbar.create({
                isSelfclosing: !notification.showAlways,
                isSuppressible: !notification.showAlways,
                type: notification.type || 'info',
                uniqueKey: notification.uniqueKey,
                children: [
                  {
                    component: 'notification',
                    data: {
                      type: notification.type || 'info',
                      text: content.text,
                      button: content.button,
                    },
                  },
                ],
              });
            }, index * 300);
          });
      })
      .catch(console.info);
  };

  let hasMeAPiBeenCalledResolver;
  const isLoggedIn = () => {
    if (isClickDummy) {
      return window.swinger.storage.get('swinger.user.authenticated') === true;
    }

    const me = window.swinger.storage.get('me');

    if (me) {
      return !!me.id;
    }

    return !!window.swinger.cookie.get('logged_in');
  };

  window.swinger = {
    ...window.swinger,
    user: {
      wasLoggedInOnPageLoad: isLoggedIn(),
      isLoggedIn,
      hasMeAPiBeenCalled: new Promise((resolve) => {
        hasMeAPiBeenCalledResolver = resolve;
      }),
      getCsrfData() {
        return csrf || {};
      },
      getId() {
        const me = window.swinger.storage.get('me');

        return me && me.id;
      },
      getLevel() {
        const me = window.swinger.storage.get('me');

        return me && me.level;
      },
      getGeo() {
        const me = window.swinger.storage.get('me');

        return me && me.geo;
      },
      getVatPercentage() {
        const me = window.swinger.storage.get('me');

        return (me && me.vatPercentage) || 0;
      },
      getDisplayMode() {
        const me = window.swinger.storage.get('me');

        return (me && me.preferences && me.preferences.displayMode) || 'light';
      },
      getCurrency() {
        const me = window.swinger.storage.get('me');

        return me && me.currency;
      },
      getAuthKey() {
        const me = window.swinger.storage.get('me');

        return me && me.authKey;
      },
      getItemNotificationState(id) {
        const me = window.swinger.storage.get('me');

        id = `${id}`;

        return !!(me && me.watchedItems && me.watchedItems.find((entry) => `${entry}` === id));
      },
      getAllOwnedItemNumbers() {
        const me = window.swinger.storage.get('me');

        switch (true) {
          default:
          case !me || !me.library:
          case ['undefined', 'number', 'string'].indexOf(typeof me.library) > -1:
          case me.library === null:
            return [];

          case Array.isArray(me.library):
            return me.library;

          case typeof me.library === 'object':
            return Object.keys(me.library);
        }
      },
      getItemOwnState(id) {
        if (!id) {
          return false;
        }

        id = `${id}`;
        const { 0: baseItemNumber } = id.split('-');

        const me = window.swinger.storage.get('me');

        switch (true) {
          default:
          case !me || !me.library:
          case ['undefined', 'number', 'string'].indexOf(typeof me.library) > -1:
          case me.library === null:
            return false;

          case Array.isArray(me.library):
            return !!(me && me.library && me.library.find((entry) => `${entry}` === baseItemNumber || `${entry}` === id));

          case me.library[baseItemNumber] !== undefined:
            switch (true) {
              default:
                return me.library[baseItemNumber];

              case me.library[baseItemNumber] === true:
                return {
                  status: 'purchased',
                };

              case me.library[baseItemNumber] === null:
                return {
                  status: 'rented',
                };

              case Number(me.library[baseItemNumber]) === me.library[baseItemNumber]:
                return {
                  status: 'rented',
                  rentalEndTimestamp: me.library[baseItemNumber],
                };
            }

          case me.library[id] !== undefined:
            switch (true) {
              default:
                return me.library[id];

              case me.library[id] === true:
                return {
                  status: 'purchased',
                };

              case me.library[id] === null:
                return {
                  status: 'rented',
                };

              case Number(me.library[id]) === me.library[id]:
                return {
                  status: 'rented',
                  rentalEndTimestamp: me.library[id],
                };
            }
        }
      },
      getCartItems() {
        const me = window.swinger.storage.get('me') || {};

        return (me.cart && me.cart.items) ? me.cart.items : [];
      },
      getStudioPromotion(id) {
        const me = window.swinger.storage.get('me') || {};
        const userLevel = window.swinger.user.getLevel();
        const now = (new Date()).getTime() / 1000;

        if (
          !id
          || !me.promotions
          || !me.promotions.length
        ) {
          return undefined;
        }

        id = Number(id);

        return me.promotions.find((promotion) => {
          if (
            !promotion.trigger
            || !promotion.trigger.studio
            || promotion.trigger.studio.indexOf(id) === -1
          ) {
            return false;
          }

          if (
            promotion.valid
            && promotion.valid.from
            && promotion.valid.from > now
          ) {
            return false;
          }

          if (
            promotion.valid
            && promotion.valid.until
            && promotion.valid.until < now
          ) {
            return false;
          }

          if (
            promotion.customerLevel
            && promotion.customerLevel.length
            && promotion.customerLevel.indexOf(userLevel) === -1
          ) {
            return false;
          }

          return true;
        });
      },
      updateUserData() {
        const promotions = window.swinger.storage.get('promotions');

        window.swinger.api.me()
          .then((result) => {
            if (typeof result !== 'object') {
              return;
            }

            if (result.csrf) {
              csrf = result.csrf;
              delete result.csrf;
            }

            const me = window.swinger.storage.get('me') || {};

            result.preferences = result.preferences || {};
            me.preferences = me.preferences || {};

            const preferenceKeys = [
              ...new Set([
                ...Object.keys(result.preferences),
                ...Object.keys(me.preferences),
              ]),
            ];

            preferenceKeys.forEach((key) => {
              if (result.preferences[key] == null && me.preferences[key] != null) {
                result.preferences[key] = me.preferences[key];
              }
            });

            result.promotions = promotions;

            window.swinger.storage.set('me', result);

            if (result.notifications && result.notifications.length) {
              triggerNotifications(result.notifications);
            }

            if (window.swinger.user.isLoggedIn() && result.id === undefined) {
              window.swinger.cookie.remove('logged_in');
            }

            if (result.isConfirmed) {
              window.swinger.storage.remove('swinger.verification');
            }

            window.swinger.eventHub.trigger(document, 'swinger.user:authchange');
            window.swinger.eventHub.trigger(document, 'swinger.user:afterInitialUpdate');
            hasMeAPiBeenCalledResolver(true);
          })
          .catch((e) => {
            console.log('Fetching user data via me API resulted in an error', e);
          });

        window.swinger.api.getPromotions()
          .then((result) => {
            const promotions = result.promotions;
            window.swinger.storage.set('promotions', promotions);

            const me = window.swinger.storage.get('me');
            if (!me) {
              return;
            }
            me.promotions = promotions;
            window.swinger.storage.set('me', me);
          })
          .catch(console.info);
      },
    },
  };

  setClasses(window.swinger.user.isLoggedIn());

  document.addEventListener('swinger.user:authchange', () => {
    setClasses(window.swinger.user.isLoggedIn());
  });

  const attachUpdateUserData = () => {
    window.removeEventListener('pageshow', attachUpdateUserData);
    window.addEventListener('pageshow', window.swinger.user.updateUserData);
  };

  window.addEventListener('pageshow', attachUpdateUserData);

  window.swinger.user.updateUserData();

  window.addEventListener('storage', () => {
    window.setTimeout(() => {
      if (window.swinger.eventHub) {
        window.swinger.eventHub.trigger(document, 'swinger.user:authchange');
      }
    });
  });
})();
